import { Parser } from '@json2csv/plainjs';

const opts = {
  fields: [
    {
      label: 'Node Number',
      value: 'nodeNumber',
    },
    {
      label: 'Node Type',
      value: (record?: { nodeType?: string }) => {
        if (record?.nodeType) {
          return record.nodeType.toUpperCase();
        }

        return 'D';
      },
    },
    {
      label: 'Node Name',
      value: 'nodeName',
    },
    {
      label: 'Intent',
      value: 'intent',
    },
    {
      label: 'NLU Disabled?',
      value: (record?: { nluDisabled?: boolean }) => {
        if (record?.nluDisabled === true) return 1;
        return undefined;
      },
    },
    {
      label: 'Next Nodes',
      value: (record?: { nextNodes?: number[] }) => {
        if (record?.nextNodes && record?.nextNodes.length) {
          return record?.nextNodes[0];
        }

        return '';
      },
    },
    {
      label: 'Message',
      value: 'message',
    },
    {
      label: 'Rich Asset Type',
      value: (record?: { richAssetType?: string }) => {
        if (!record?.richAssetType) return undefined;
        if (record.richAssetType === 'none') return undefined;

        return record.richAssetType;
      },
    },
    {
      label: 'Rich Asset Content',
      value: (record?: { richAssetContent?: string }) => {
        if (!record?.richAssetContent) return undefined;
        return record.richAssetContent;
      },
    },
    {
      label: 'Answer Required?',
      value: (record: { answerRequired?: boolean }) => {
        if (record.answerRequired === true) return 1;
        return undefined;
      },
    },
    {
      label: 'Behaviors',
      value: (record?: { behaviors?: string[] }) => {
        if (
          record?.behaviors &&
          Array.isArray(record.behaviors) &&
          record?.behaviors.length
        ) {
          return record.behaviors.join(',');
        }

        return null;
      },
    },
    {
      label: 'Command',
      value: 'command',
    },
    {
      label: 'Description',
      value: 'description',
    },
    {
      label: 'Output',
      value: (record?: { output?: string[] }) => {
        if (
          record?.output &&
          Array.isArray(record.output) &&
          record?.output.length
        ) {
          return record.output.join(',');
        }

        return null;
      },
    },
    {
      label: 'Node Input',
      value: 'nodeInput',
    },
    {
      label: 'Parameter Input',
      value: 'parameterInput',
    },
    {
      label: 'Decision Variable',
      value: 'decisionVariable',
    },
    {
      label: 'What Next?',
      value: (record?: { whatsNext?: string[] }) => {
        if (
          record?.whatsNext &&
          Array.isArray(record.whatsNext) &&
          record?.whatsNext.length
        ) {
          return record.whatsNext?.join('|');
        }
        return null;
      },
    },
    {
      label: 'Node Tags',
      value: 'nodeTags',
    },
    {
      label: 'Skill Tag',
      value: 'skillTag',
    },
    {
      label: 'Variable',
      value: (record?: { variables?: string[] }) => {
        if (
          record?.variables &&
          Array.isArray(record.variables) &&
          record?.variables.length
        ) {
          return record.variables.join(',');
        }

        return '';
      },
    },
    {
      label: 'Platform Flag',
      value: 'platformFlag',
    },
    {
      label: 'Utterances',
      value: 'utterances',
    },
    {
      label: 'CSS Classname',
      value: 'cssClassname',
    },
    {
      label: 'Event',
      value: 'analyticsEvent',
    },
  ],
};

export const json2csvParser = new Parser(opts);
